export enum FilterSectionsFormBlock {
  Root = 'FilterSectionsForm',
}

export enum FilterSectionsFormElement {
  Sections = 'sections',
}
